<cb-dialog [dialogHeading]="!mappedItem.id ? 'New Question' : 'Edit Question'">
    <form class="flex-col flex" #questionForm="ngForm">
        @if (data.childItems) {
            <cb-select
                [label]="data.childItemLabel"
                name="childEntityId"
                [(ngModel)]="mappedItem.childEntityId"
                [options]="data.childItems"
                [readonly]="mappedItem?.id != null"
            ></cb-select>
        }
        <div class="start-center flex-row">
            <cb-input
                type="text"
                label="Current User"
                name="currentUserName"
                [ngModel]="currentUser.profile.name"
                [readonly]="true"
            ></cb-input>
            @if (currentUserTeams.length > 1) {
                <span class="cb-margin-left cb-margin-right">&nbsp;as&nbsp;</span>
            }
            @if (currentUserTeams.length > 1) {
                <cb-select
                    style="margin-top: 10px"
                    label="Team"
                    name="userTeam"
                    [(ngModel)]="mappedItem.createdByTeamCode"
                    [options]="currentUserTeams"
                    [required]="true"
                    valueProp="key"
                ></cb-select>
            }
        </div>
        <div class="start-center flex-row">
            <cb-user-autocomplete-scroller
                label="Question To"
                name="questionTo"
                [(ngModel)]="recipient"
                [required]="true"
                [matchProps]="['id']"
                (change)="recipientChanged()"
                [active]="true"
            ></cb-user-autocomplete-scroller>
            @if (recipientTeams.length > 1) {
                <span class="cb-margin-left cb-margin-right">&nbsp;as&nbsp;</span>
            }
            @if (recipientTeams.length > 1) {
                <cb-select
                    label="Team"
                    name="recipientTeam"
                    [(ngModel)]="mappedItem.teamCode"
                    [required]="true"
                    [options]="recipientTeams"
                    valueProp="key"
                ></cb-select>
            }
        </div>
        <cb-text-area
            label="Question"
            name="question"
            [(ngModel)]="mappedItem.request"
            [maxlength]="1024"
            [required]="true"
        ></cb-text-area>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="!recipient.name"
            (cbClick)="save()"
            [clickLimit]="1"
        >
            {{ !mappedItem.id ? 'Create' : 'Save' }}
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
